import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { StText } from './text.styled';
import { textProps } from './text.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkText',
  props: textProps,
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StText), _mergeProps({ as: _ctx.as }, _ctx.$props), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["as"]))
}
}

})